import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { LinksService } from '@app/core/links.service';
import { Membership } from '@app/core/membership';
import { MembershipService } from '@app/core/membership.service';
import { MODULE_DIRECT_SIGN_UP_SELECTION_PAGE, MODULE_EMAIL_VERIFICATION_PAGE } from '@app/core/mixpanel.constants';
import { StepName } from '@app/registration/enterprise/registration-step-name';

import { ChildRegistrationAction, RegistrationAnalyticsService } from '../../registration-analytics.service';
import { RegistrationStepDirective } from '../registration-step.directive';

@Component({
  selector: 'om-pediatric-direct-signup-success-step',
  templateUrl: './pediatric-direct-signup-success-step.component.html',
})
export class PediatricDirectSignupSuccessStepComponent extends RegistrationStepDirective implements OnInit {
  @Input() patientEmail: string;
  @Input() module: string;
  @Input() isWhitelisted: boolean;
  @Output() nextStepSelected = new EventEmitter<StepName>();

  private readonly membership: Observable<Membership>;

  constructor(
    private links: LinksService,
    private analytics: RegistrationAnalyticsService,
    private membershipService: MembershipService,
  ) {
    super();
    this.membership = this.membershipService.getMembership().pipe(take(1));
  }

  trackAddAnotherChildClicked = () =>
    this.membership.pipe(
      map(({ omMembershipType }) =>
        this.analytics.confirmationActionSelected({
          action: ChildRegistrationAction.addAnother,
          isLoggedIn: true,
          omMembershipType,
        }),
      ),
    );

  ngOnInit(): void {
    this.membership.subscribe({
      next: ({ omMembershipType }) =>
        this.analytics.confirmationPageViewed({
          isLoggedIn: true,
          omMembershipType,
          referrer: MODULE_EMAIL_VERIFICATION_PAGE,
        }),
    });
  }

  goToNextStep() {
    window.location.href = `${this.links.onboarding}?source=${MODULE_DIRECT_SIGN_UP_SELECTION_PAGE}`;
  }

  goToStep(step: StepName) {
    this.nextStepSelected.emit(step);
    this.submit.emit();
  }
}
